export default __webpack_public_path__ + "static/media/meetingbanner.1935725a.png";